import { healthMonitor } from './menu/health-monitor';
import { home } from './menu/home';
import { user } from './menu/user';
import { statistics } from './menu/statistics';
import { cashRegister } from './menu/cash-register';

export const menus = [home, statistics, cashRegister, healthMonitor, user];
